/* eslint-disable no-underscore-dangle */
export const checkHasSubscription = (items) => items.some((item) => item.properties._subscription_id);
